import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Modal } from 'antd';
import { Grid, Card } from '@material-ui/core';
import MainContainer from '../../../components/MainContainer';
import OutOfStockRecipientList from '../../../components/AdminOutOfStockRecipient/List/OutOfStockRecipientList';
import UpdateOutOfStockRecipientModal from '../../../components/AdminOutOfStockRecipient/Update/OutOfStockRecipientUpdate';

@inject('outOfStockRecipientStore')
@observer
class OutOfStockRecipientPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        this.props.outOfStockRecipientStore.init();
    }

    handleCancelUpdateOutOfStockRecipientModal = () => {
        this.props.outOfStockRecipientStore.setShowUpdateOutOfStockRecipientModal(false);
    }

    handleCancelSearchMenuIteModal = () => {
        this.props.outOfStockRecipientStore.setShowSearchMenuItemModal(false);
    }

    render() {
        const { 
            showUpdateOutOfStockRecipientModal, 
            manageOutOfStockRecipientTitle
        } = this.props.outOfStockRecipientStore;

        return (
            <MainContainer title='Out of Stock Recipient' menukey='outofstockrecipient'>
                <Modal
                    title={manageOutOfStockRecipientTitle}
                    visible={showUpdateOutOfStockRecipientModal}
                    width={800}
                    footer={null}
                    onCancel={this.handleCancelUpdateOutOfStockRecipientModal}
                    zIndex={1000}
                >
                    <UpdateOutOfStockRecipientModal />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <OutOfStockRecipientList />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default OutOfStockRecipientPage;